import React, { useEffect, useState } from "react";
import { fetchHomeOverview } from "../api";

export default function HomePanel() {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;

    const run = async () => {
      try {
        const result = await fetchHomeOverview();
        if (!cancelled) {
          setData(result);
        }
      } catch (err) {
        if (!cancelled) {
          setError(err.message || "Failed to load module.");
        }
      }
    };

    run();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <section className="panel panel--padded">
      <div className="info-banner">
        <div>
          <div className="dashboard-brand__eyebrow">Workspace status</div>
          <h2 className="section-title" style={{ marginTop: 8 }}>Demo environment online</h2>
          <p className="dashboard-copy" style={{ marginBottom: 0 }}>
            The original starter panel has been restyled into a compact SaaS summary card so the todo board
            remains the hero section.
          </p>
          {error ? <p className="error-text">{error}</p> : null}
        </div>

        <div className="info-banner__stats">
          <div className="pill-stat">
            <div className="pill-stat__label">API status</div>
            <div className="pill-stat__value">{data?.status || "…"}</div>
          </div>
          <div className="pill-stat">
            <div className="pill-stat__label">Message</div>
            <div className="pill-stat__value" style={{ fontSize: 16 }}>{data?.message || "Loading"}</div>
          </div>
        </div>
      </div>
    </section>
  );
}
